<template>
  <Landing v-if="status && status != STATUS.ACTIVE && status != STATUS.TRIAL"> <!--TODO: revisar seguridad -->
    <v-container>
      <v-row>
        <v-col v-if="status === STATUS.WELCOME">
          <Welcome @nextStep="afterWelcome" />
        </v-col>
        <v-col v-else-if="status === STATUS.INSTALLATION_OK">
          <LandingContent
            :id="generateFKPI('status-ok')"
            title="Enhorabuena!"
            subtitle="La instalación del conector se ha realizado con éxito."
            button="Terminar"
            @nextStep="afterInstallationOk"
          />
        </v-col>
        <v-col v-else-if="status === STATUS.INSTALLATION_KO">
          <LandingContent
            :id="generateFKPI('status-ko')"
            title="Error"
          >
            Algo no ha ido bien durante el proceso de instalación.
            <br />Contacta con nuestro servicio técnico: soporte@inmatic.ia
          </LandingContent>
        </v-col>
        <v-col v-else-if="status === STATUS.INSTALLING_CONNECTOR">
          <div
            :id="generateFKPI('status-in-process')"
            class="text-center"
          >
            <v-progress-circular
              indeterminate
              size="300"
              width="10"
              style="margin-top: 10%"
              color="yellow"
            ></v-progress-circular>
          </div>
        </v-col>
        <v-col v-else>
          <v-stepper v-model="stepper">
            <v-stepper-header v-if="stepper > 2">              
              <v-stepper-step class="pt-0 pb-0" v-if="stepper < 3" :complete="stepper > 1" step="1"></v-stepper-step>
              <v-divider v-if="stepper < 3"></v-divider>
              <v-stepper-step class="pt-0 pb-0" v-if="stepper < 3" :complete="stepper > 2" step="2"></v-stepper-step>              
              
              <v-stepper-step class="pt-0 pb-0" v-if="stepper > 2" :complete="stepper > 3" step="3"></v-stepper-step>
              <v-divider v-if="stepper > 2" ></v-divider>
              <v-stepper-step class="pt-0 pb-0" v-if="stepper > 2" :complete="stepper > 4" step="4"></v-stepper-step>
              <v-divider v-if="stepper > 2"></v-divider>
              <v-stepper-step class="pt-0 pb-0" v-if="stepper > 2" :complete="stepper > 5" step="5"></v-stepper-step>
              <v-divider v-if="stepper > 2"></v-divider>
              <v-stepper-step class="pt-0 pb-0" v-if="stepper > 2" :complete="stepper > 6" step="6"></v-stepper-step>
              <!-- <v-divider></v-divider>
              <v-stepper-step :complete="stepper > 6" step="6"></v-stepper-step> -->
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content class="pt-0" v-if="stepper < 3" step="1">
                <CreateUser :id="generateFKPI('create-user')" v-if="stepper == 1" />
              </v-stepper-content>
              <!--
              <v-stepper-content class="pt-0" v-if="stepper < 3" step="2">
                <SelectPlan :id="generateFKPI('select-plan')" v-if="stepper == 2" @previousStep="previousStep" />
              </v-stepper-content>-->
              <v-stepper-content class="pt-0" v-if="stepper > 2" step="3">
                <Installation :id="generateFKPI('connector-installation')" v-if="stepper == 3" @previousStep="previousStep" />
              </v-stepper-content>
              <v-stepper-content class="pt-0" v-if="stepper > 2" step="4">
                <AccountingProgramData :id="generateFKPI('accounting-program-data')" v-if="stepper == 4" @previousStep="previousStep" />
              </v-stepper-content>
              <v-stepper-content class="pt-0" v-if="stepper > 2" step="5">
                <training-data :id="generateFKPI('training-data')" v-if="stepper == 5" @previousStep="previousStep" />
              </v-stepper-content>
              <v-stepper-content class="pt-0" v-if="stepper > 2" step="6">
                <training-ready :id="generateFKPI('training-ready')" v-if="stepper == 6" @previousStep="previousStep" />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-container>
  </Landing>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { user as api_user } from "@/api/user";
import { STATUS } from "@/store/modules/me.js";

import Landing from "@/components/layout/Landing";
import LandingContent from "@/components/WelcomeSteps/LandingContent";
import Welcome from "@/components/WelcomeSteps/Welcome";
import CreateUser from "@/components/WelcomeSteps/CreateUser";
import WatchTutorial from "@/components/WelcomeSteps/WatchTutorial";
import SelectPlan from "@/components/WelcomeSteps/SelectPlan";
import Installation from "@/components/WelcomeSteps/Installation";
import TrainingData from "@/components/WelcomeSteps/TrainingData";
import TrainingReady from "@/components/WelcomeSteps/TrainingReady";
import AccountingProgramData from "@/components/WelcomeSteps/AccountingProgramData";

export default {
  name: "WelcomeSteps",
  components: {
    Landing,
    LandingContent,
    Welcome,
    CreateUser,
    WatchTutorial,
    SelectPlan,
    Installation,
    TrainingData,
    TrainingReady,
    AccountingProgramData,
  },
  data() {
    return {
      STATUS,
      status: STATUS.WELCOME,
      stepper: 1,
    };
  },
  created() {
    this.initialSetUp();
  },
  methods: {
    afterWelcome() {
      this.status = STATUS.FILLING_FORM;
    },
    async afterInstallationOk() {
      // if we change the status to DOING_TUTORIAL
      // the tutorial should start and change the route on first step
      const response = await api_user.setUserInfo({
        status: STATUS.DOING_TUTORIAL,
      });
      this.setUserData(response.data.results);
    },
    previousStep() {
      this.stepper--;
    },
    nextStep() {
      this.stepper++;
    },
    checkInstallation() {
      // Polling userData
      // We expect to change status from INSTALLING_CONNECTOR to another
      const timeout = setTimeout(() => {
        clearInterval(interval);
        this.status = STATUS.INSTALLATION_KO;
      }, 61000);

      const interval = setInterval(async () => {
        const response = await api_user.getUserData({});
        if (response.data.results.status !== STATUS.INSTALLING_CONNECTOR) {
          this.setUserData(response.data.results);
          clearTimeout(timeout);
          clearInterval(interval);
        }
      }, 5000);
    },
    initialSetUp() {
      this.status = this.userData.status;
      switch (this.userData.status) {
        case STATUS.READING_CONTRACT:
          this.stepper = 2;
          break;
        case STATUS.DOWNLOADING_CONNECTOR:
          this.stepper = 3;
          break;
        case STATUS.FILLING_PROGRAM_DATA:
          this.stepper = 4;
          break;
        case STATUS.INSTALLING_CONNECTOR:
          this.checkInstallation();
          break;
        case STATUS.PREPARING_FORMATION:
          this.stepper = 5;
          break;
        case STATUS.READY_FOR_FORMATION:
          this.stepper = 6;
          break;
        default:
          break;
      }
    },
    generateFKPI(step) {
      return `fkpi-app-installation-${step}`
    },
    
    ...mapActions({
      setUserData: "me/setUserData",
    }),
  },
  computed: {
    ...mapGetters({
      me: "me/me",
      userData: "me/userData",
    }),
  },
  watch: {
    userData: function () {
      this.initialSetUp();
    },
  },
};
</script>

